import styled from 'styled-components';
import { colors } from 'globalStyles';
import { media } from 'utils/style-utils'

export const Wrapper = styled.div`
  padding-top: 132px;
  ${media.mobile_and_tablet`
    padding-top: 80px;
  `}
  ${media.mobile`
    padding-top: 80px;
  `}
`;

export const Heading = styled.div`
  font-size: 16px;
  padding: ${({ email }) => email ? '44px 0 0 0' : '0 20px 37px'};
  text-align: center;
`;

export const ButtonGroup = styled.div`
  text-align: center;

  > button {
    max-width: 128px;
    width: 100%;
    height: 40px;
    box-shadow: 0px 5px 15px 0px ${colors.LIGHT_MAIN_COLOR};
    -webkit-appearance: none;
  }
`;

export const StyledForm = styled.form`
  margin-bottom: 50px;
`;


export const CheckboxLabel = styled.div`
  > a,
  > a:hover {
    text-decoration: underline;
  }
`;

export const FormButtonGroup = styled.div`
  text-align: center;
  padding-top: 30px;

  > button {
    padding: 10px 50px;
  }
`;

export const ContactUs = styled.div`
  position: absolute;
  height: 38px;
  bottom: 0px;
  background-color: ${colors.WHITE};
  font-size: 12px;
  padding: 0 20px;

  > a,
  > a:hover {
    color: ${colors.MAIN_COLOR};
  }
`


// WEBPACK FOOTER //
// ./src/containers/SignInPage/styledComponents.js